<template>
  <div class="upload-pan-container">
    <loading :loading="loading"></loading>
    <error-alert-dialog
      :show-error-alert-dialog="showErrorAlertDialog"
      :error="networkError" @dismissClicked="showErrorAlertDialog=false">
    </error-alert-dialog>
    <activity-redirect-item
      :loan-tasks="tasks"
      :current-loan-task="currentTaskName"
      :is-loan-task="true"
      :redirect-activity="redirectActivity"></activity-redirect-item>


    <image-activity
      class="image_activity"
      :toolbar-title="title"
      :tasks="tasks"
      :upload-to-mifos="uploadToMifos" :directory="directory"
      :entity-type="entityType" :entity-id="clientId"
      :attach-document-description="attachDocumentDescription"
      :attach-document-button-text="attachDocumentButtonText"
      :image-activity-type="imageActivityType"
      :document-preview-description="documentPreviewDescription"
      :reattach-document-text="reattachDocumentText"
      :identifier-required="true"
      identifier-label="PAN ID"
      :identifier="panNumber"
      :document-attached="documentAttached"
      @onPanDocumentUploaded="onPanDocumentUploaded"
      @uploadFailed="loading=false"
      @uploadStarted="uploadDocumentStarted">
    </image-activity>

    <wxc-button
      v-if="processPanData()"
      text="Skip"
      type="blue"
      class="btnStyle"
      @wxcButtonClicked="skipUpload"
    ></wxc-button>
  </div>
</template>

<script>
import ImageActivity from "./ImageActivity";
import { Constants } from "@/components/Constants";
import WxcButton from "@/../weex-ui/packages/wxc-button/index";
import clientIdentifierUtility from "../../../utils/ClientIdentifierUtility";
import dataSource from "../../../data/DataSource";
import alertService from "../../core/alert/AlertService";
import EzUtils from "../../../utils/EzUtils";
import ImageUtils from "../../../utils/ImageUtils";
import loanScopeDataHolder from "@/data/model/LoanScopeDataHolder";
import LoanTaskActivityNavigator from "@/utils/LoanTasksActivityNavigator";
import Loading from "../../layout/Loading";
import ErrorAlertDialog from "@/components/dialogs/ErrorAlertDialog";
import ActivityRedirectItem from "../../layout/ActivityRedirectItem";
import { Activities } from "@/utils/ActivityNavigator";

export default {
  name: "Upload Pan Activity",
  components: {
    ActivityRedirectItem,
    ErrorAlertDialog,
    ImageActivity,
    WxcButton,
    Loading
  },
  data: () => ({
    title: "Pan Image",
    attachDocumentDescription: "Upload PAN Card Copy",
    attachDocumentButtonText: "Attach Pan Card",
    reattachDocumentText: "Reattach Pan Card",
    documentPreviewDescription: "Preview Pan Card",
    directory: Constants.PAN_IMAGE_NAME,
    entityType: Constants.CLIENTS,
    uploadToMifos: Constants.DO_NOT_UPLOAD,
    imageActivityType: Constants.PAN_IMAGE_IMAGE_ACTIVITY,
    identifier: {},
    createNewIdentifier: true,
    clientIdentifierId: 0,
    identifierImageExist: false,
    document: null,
    panImageFound: false,
    clientImageUrl: "",
    panNumber: "",
    documentAttached: false,
    fileName: "",
    loading: false,
    showErrorAlertDialog: false,
    networkError: {},
    clientId: loanScopeDataHolder.getClientId()
  }),
  methods: {
    onPanIdentifierFound(identifier) {
      this.identifier = identifier;
      this.panNumber = identifier.documentKey;
      this.createNewIdentifier = false;
      this.clientIdentifierId = identifier.id;
      dataSource.getDocuments(Constants.CLIENTS, loanScopeDataHolder.getClientId())
        .then(documentData => {
          if (documentData.errorOccurred) {
            alertService.alert({ message: documentData.data })
          } else {
            let documents = documentData.data;
            const panDocuments = documents.filter(document =>
              document.name != null &&
              Constants.PAN_IMAGE_NAME.toLowerCase() === document.name.toLowerCase()
            );
            if (EzUtils.isNotEmpty(panDocuments)) {
              this.onPanDocumentFound(panDocuments[panDocuments.length - 1])
            }
          }
        })
    },
    uploadDocumentStarted() {
      this.loading = true
    },
    onPanDocumentFound(panDocument) {
      this.panImageFound = true;
      this.documentAttached = true
      if (panDocument != null) {
        ImageUtils.getClientImageUrl(loanScopeDataHolder.getClientId(), panDocument.id)
          .then(url => {
            this.clientImageUrl = url
          });
        if (this.document == null || this.document.id === 0) {
          this.document = panDocument;
        }
      }
    },
    onPanDataFound(identifier, document) {
      this.document = document;
      this.onPanIdentifierFound(identifier);
      this.identifierImageExist = true;
    },
    processPanData() {
      return (this.document != null && this.document.id !== 0)
    },
    skipUpload() {
      if (this.document.parentEntityId === loanScopeDataHolder.getClientId()) {
        this.createDocumentLocationForIdentifier()
          .then(res => {
            this.getNextTask()
          })
      } else {
        this.getNextTask();
      }
    },
    getNextTask() {
      this.loading = true;
      LoanTaskActivityNavigator.getNextTask(this.tasks)
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.networkError = res.data;
            this.showErrorAlertDialog = true;
          }
        });
    },
    createDocumentLocationForIdentifier() {
      return dataSource.createDocumentLocation(
        "client_identifiers",
        this.clientIdentifierId,
        Constants.PAN_IMAGE_NAME.toLowerCase(),
        Constants.getDescription(Constants.PAN_IMAGE_NAME),
        this.document.fileName,
        this.document.location
      )
    },
    createDocumentLocationForIdentifiers(clientId, clientIdentifierId) {
      dataSource.createDocumentLocation(Constants.CLIENTS, clientId,
        this.directory.toUpperCase(),
        Constants.getDescription(this.directory), this.fileName, this.getAwsPath())
        .then(res => {
          dataSource.createDocumentLocation("client_identifiers", clientIdentifierId,
            this.directory.toLowerCase(),
            Constants.getDescription(this.directory), this.fileName,
            this.getAwsPath()).then(res => {
            this.getNextTask()
          })
        })
    },
    onPanDocumentUploaded(event) {
      console.log(event.identifier)
      this.identifier = event.identifier;
      this.fileName = event.fileName;
      if (this.createNewIdentifier) {
        dataSource.createClientIdentifierUsingMifos(loanScopeDataHolder.getClientId(),
          { "documentType": "PAN", "description": "Pan Card" }, event.identifier)
          .then(res => {
            this.createDocumentLocationForIdentifiers(loanScopeDataHolder.getClientId(),
              res.data.resourceId)
          }).then(res => {
          this.getNextTask();
        })
      } else if (!this.identifierImageExist) {
        this.createDocumentLocationForIdentifiers(loanScopeDataHolder.getClientId(),
          this.clientIdentifierId)
      }
    },
    getAwsPath() {
      return "documents" + "/"
        + this.entityType + "/"
        + loanScopeDataHolder.getClientId() + "/"
        + this.directory + "/" + this.directory.toUpperCase();
    },
    fetchInitialData() {
      clientIdentifierUtility.getClientIdentifier(loanScopeDataHolder.getClientId(),
        { "documentType": "PAN", "description": "Pan Card" })
        .then(identifier => {
          if (identifier.errorOccurred) {
            alertService.alert({ message: identifier })
          } else {
            dataSource.getDocuments("client_identifiers", identifier.id)
              .then(documents => {
                if (identifier.errorOccurred) {
                  this.onPanIdentifierFound(identifier)
                } else {
                  if (EzUtils.isEmpty(documents.data)) {
                    this.onPanIdentifierFound(identifier)
                  } else {
                    this.onPanDataFound(identifier, documents.data[0])
                  }
                }
              })
          }
        })
    }
  },
  created: function () {
    this.fetchInitialData()
  },

  computed: {
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.PAN_IMAGE, Activities.PAN_ADDED]
    },

    currentTaskName() {
      if (loanScopeDataHolder.getCurrentLoanTask()
        && loanScopeDataHolder.getCurrentLoanTask().name) {
        return loanScopeDataHolder.getCurrentLoanTask().name
      }
      return '';
    }
  }
};
</script>

<style scoped>
.upload-pan-container {
  background-color: #ffffff;
}

.image_activity {
  height: 300px;
}

.btnStyle {
  margin: 500px 20px 0;
  width: 620px;
  height: 94px;
}
</style>
